/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {useMemo, useState} from 'react';
import {useParams} from 'react-router';
import {Concept} from 'types';
import {useLocalization} from 'localization';
import {CodeListsGate} from 'services/codelists';
import {isUuid} from 'services/utils/functions/isUuid';
import {Scene} from 'components';
import {
  SceneExtensionsContext,
  useLinkedValueSearchSceneExtensionCore,
  useSceneExtensionsContextProviderValue,
} from 'sceneExtensions';
import type {VerifiedLinkedCatalogPostLink} from '../../schemaDefinition/types';
import {MergeSeriesSceneCore} from './MergeSeriesSceneCore';
import {useCollectionsCodelistIds} from './hooks/useCollectionsCodelistIds';

export const MergeSeriesScene = () => {
  const collectionsCodelistIds = useCollectionsCodelistIds();

  const linkedValueSearchExtension = useLinkedValueSearchSceneExtensionCore({
    canToggleFullWidth: true,
  });
  const extensions = useMemo(
    () => [linkedValueSearchExtension],
    [linkedValueSearchExtension],
  );
  const sceneExtensionContext =
    useSceneExtensionsContextProviderValue(extensions);

  const {t} = useLocalization();
  const {seriesId: seriesIdParam, otherId: otherIdParam} = useParams();

  const [seriesId, setSeriesId] = useState<string>(seriesIdParam || '');
  const [otherId, setOtherId] = useState<string>(otherIdParam || '');

  const validIds = seriesId !== otherId && isUuid(seriesId) && isUuid(otherId);

  const linkedValue: VerifiedLinkedCatalogPostLink = {
    linkStatus: 'verified',
    entityId: seriesId,
    type: Concept.series,
    name: 'hola',
  };

  return (
    <CodeListsGate codeLists={collectionsCodelistIds}>
      <SceneExtensionsContext.Provider value={sceneExtensionContext}>
        <Scene browserTitle={t('appbar.series')}>
          <Scene.Header title={'Seriesammenslåing'} />
          <Scene.Content>
            {/*}
            <FlexBox left horizontal gap={2} marginBottom={4}>
              <LinkedField
                name={'linkedSeriesId'}
                label={'Series ID'}
                required={true}
                readonly={false}
                showWhenReadonlyAndEmpty={true}
                entity={Concept.collection}
                entitySubtypes={[
                  Concept.series,
                  Concept.educationalSeries,
                  Concept.publisherSeries,
                  Concept.otherConnection,
                ]}
                error={!linkedValue}
                link={linkedValue}
                formattedValue={linkedValue.name}
                onChange={() => undefined}
                onBlur={() => undefined}
              />
              <TextField
                type={'text'}
                name={'seriesId'}
                label={'Series ID'}
                value={seriesId}
                onChange={event => setSeriesId(event.target.value)}
                slotProps={{
                  input: {
                    sx: {width: '360px'},
                  },
                }}
              />
              <TextField
                type={'text'}
                name={'otherId'}
                label={'Other ID'}
                value={otherId}
                onChange={event => setOtherId(event.target.value)}
                slotProps={{
                  input: {
                    sx: {width: '360px'},
                  },
                }}
              />
            </FlexBox>
            {*/}
            {validIds ? (
              <MergeSeriesSceneCore seriesId={seriesId} otherId={otherId} />
            ) : (
              <div>Please enter two valid series UUIDs.</div>
            )}
          </Scene.Content>
        </Scene>
      </SceneExtensionsContext.Provider>
    </CodeListsGate>
  );
};
